import React from 'react';
import styles from './TextDisplay.module.css'
import getRandomLoremString from "../../../helper/randomLoremIpsum";
import {getCommentPDFAPI, getCommentTextAPI} from "../../../api/commentAPI";
import {useSelector} from "react-redux";
import Loading from "../loading/loading";
import {Document, Page} from 'react-pdf';
import {pdfjs} from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import ZoomIcon from "../icons/zoomIcon";
import OpenIcon from "../icons/openIcon";
import cleanUpHTMLTags from "../../../helper/cleanUpHTMLTags";
import DownloadIcon from "../icons/downloadIcon";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const TextDisplay = ({trackingNum, attachment, documentID}) => {

    const jwt = useSelector((state) => state.user.jwt);
    const docket = useSelector((state) => state.navigation.currentDocket);
    const s3BucketLinks = useSelector((state) => state.dockets.docketLinks);

    const [useText, setUseText] = React.useState(true);
    const [text, setText] = React.useState("")
    const [loading, setLoading] = React.useState(false)

    const renderMethod = () => {

        if (useText) {

            let newText = cleanUpHTMLTags(text)

            const lines = []
            let counter = 0
            for (let line of newText.split("<br/>")) {
                line = line.replaceAll(/(<([^>]+)>)/ig, '');
                lines.push(<span key={counter}>{line}</span>)
                lines.push(<br key={counter + 1}/>)
                counter += 2
            }

            return lines

        }

        const splitID = documentID.toString().split("-")
        const combinedID = `${splitID[0]}-${splitID[1]}-${splitID[2]}_${splitID[3]}_${attachment}`

        return <PDFElement fileURL={`${s3BucketLinks[docket]}${combinedID}.pdf`} fileName={combinedID}/>
    }

    const getHighlightedText = () => {

        return;

        let text = "";
        if (window.getSelection) {
            text = window.getSelection().toString();
        } else if (document.selection && document.selection.type != "Control") {
            text = document.selection.createRange().text;
        }

        text = text.replaceAll("\n", "  ")

        text = text.trim()

        if (text.length > 0) {
            window.alert(text)
        }

        if (window.getSelection) {
            if (window.getSelection().empty) {  // Chrome
                window.getSelection().empty();
            } else if (window.getSelection().removeAllRanges) {  // Firefox
                window.getSelection().removeAllRanges();
            }
        } else if (document.selection) {  // IE?
            document.selection.empty();
        }
    }

    React.useEffect(() => {
        if (attachment === 0 || attachment === "0") {
            setUseText(true);
            setLoading(true)
            getCommentTextAPI(jwt, docket, trackingNum, attachment).then(
                r => {
                    setText(r);
                    setLoading(false);
                }
            )
        } else {
            setUseText(false)
            setText("Attachment/PDF rendering is enabled.")
        }
    }, [trackingNum, attachment])

    return (
        <div className={styles.wrapper} onMouseUpCapture={getHighlightedText}>
            {
                loading ? <Loading/> : renderMethod()
            }
        </div>
    );
};

const PDFElement = ({fileURL, fileName}) => {

    const shouldDownload = useSelector((state) => state.prefs.pdfDownload);

    const [numPages, setNumPages] = React.useState(null);
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pdfZoom, setPDFZoom] = React.useState(0.95)
    const pdfRef = React.useRef(undefined);

    function onDocumentLoadSuccess({numPages}) {
        setNumPages(numPages);
    }

    const zoomOutFunc = () => {
        let newZoom = pdfZoom
        newZoom -= 0.1
        if (newZoom < 0.4) {
            newZoom = 0.4
        }

        setPDFZoom(newZoom)
    }

    const zoomInFunc = () => {
        let newZoom = pdfZoom
        newZoom += 0.1
        if (newZoom > 2) {
            newZoom = 2
        }

        setPDFZoom(newZoom)
    }

    const openPDF = () => {
        window.open(fileURL, "_blank", 'location=yes,height=900,width=800,scrollbars=yes');
    }

    const downloadPDF = () => {

        getCommentPDFAPI(fileURL).then(r => {

            const processBlob = async(resp) => {
                const blb = await resp.blob()

                const blob = new Blob([blb], { type: "application/pdf" });
                const url = URL.createObjectURL(blob);

                const anchorElement = document.createElement('a');
                anchorElement.href = url;
                anchorElement.download = fileName
                anchorElement.target = "_blank";

                anchorElement.click();
                anchorElement.remove();
                URL.revokeObjectURL(url);
            }

            processBlob(r)
        }).catch()
    }


    let pages = []
    if (numPages != null) {
        for (let i = 1; i <= numPages; i++) {
            if (pdfRef === undefined) {
                pages.push(<Page key={i} pageNumber={i}/>)
            } else {
                pages.push(<Page key={i} pageNumber={i} width={pdfRef.current.clientWidth} scale={pdfZoom}/>)
            }

        }
    }

    return (
        <div className={styles.pdfDiv}>
            <Document inputRef={pdfRef} file={fileURL} onLoadSuccess={onDocumentLoadSuccess}>
                {
                    pages
                }
            </Document>
            <div className={styles.zoomContainer}>
                <div className={styles.zoomBar}>
                    <button onClick={zoomInFunc} disabled={pdfZoom >= 2} className={styles.zoomButton}>
                        <ZoomIcon zoomIn={true}/>
                    </button>
                    <button onClick={zoomOutFunc} disabled={pdfZoom <= 0.4} className={styles.zoomButton}>
                        <ZoomIcon zoomIn={false}/>
                    </button>
                    {
                        shouldDownload ?
                            <button onClick={downloadPDF} className={styles.zoomButton}>
                                <DownloadIcon invert={true} />
                            </button>
                            :
                            <button onClick={openPDF} className={styles.zoomButton}>
                                <OpenIcon/>
                            </button>
                    }
                </div>
            </div>
        </div>
    )
}

export default TextDisplay;